/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PaymentExport_admin = {|
  +payments: $ReadOnlyArray<{|
    +jobId: ?string;
    +jobSessionId: ?string;
    +acceptedJobOfferId: ?string;
    +merchantReference: ?string;
    +jobStatus: ?string;
    +jobSessionStatus: ?string;
    +paymentStatus: ?string;
    +jobCreatedDate: ?string;
    +jobStartDate: ?string;
    +jobDuration: ?string;
    +requestType: ?string;
    +paymentStartedDate: ?number;
    +paymentProviderAmount: ?number;
    +paymentStudent: ?number;
    +paymentTutor: ?number;
    +paymentInternal: ?number;
    +paymentExternal: ?number;
    +studentName: ?string;
    +studentCell: ?string;
    +tutorName: ?string;
    +tutorCell: ?string;
    +tutorAccountHolder: ?string;
    +tutorAccountNumber: ?string;
    +tutorBank: ?string;
    +tutorBranchCode: ?string;
    +tutoringCompanyName: ?string;
    +tutoringCompanyCode: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "startDate",
      "type": "Date!"
    },
    {
      "kind": "RootArgument",
      "name": "endDate",
      "type": "Date!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentExport_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "endDate",
          "variableName": "endDate",
          "type": "Date!"
        },
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate",
          "type": "Date!"
        }
      ],
      "concreteType": "PaymentExport",
      "name": "payments",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentStudent",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "acceptedJobOfferId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "merchantReference",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobStatus",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobSessionStatus",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentStatus",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobCreatedDate",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobStartDate",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobDuration",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "requestType",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentStartedDate",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentProviderAmount",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "jobSessionId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentTutor",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentInternal",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "paymentExternal",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "studentName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "studentCell",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorCell",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorAccountHolder",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorAccountNumber",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorBank",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutorBranchCode",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutoringCompanyName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tutoringCompanyCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/financial/__generated__/PaymentExport_admin.graphql.js